export const menuData = {
  mainNav: [
    {
      title: 'Søk om lån',
      links: [
        { text: 'Forbrukslån', subtitle: 'Opptil 600 000 kr', url: '/forbrukslan/', icon: 'icon/coin-and-hand' },
        { text: 'Refinansiering', subtitle: 'Samle lån og kreditter', url: '/refinansiering/', icon: 'purpose/refinansiering' },
        { text: 'Billån', subtitle: 'Med og uten sikkerhet', url: '/billan/', icon: 'purpose/bil' },
        { text: 'Kredittkort', subtitle: 'Søk om flere kort', url: '/kredittkort/', icon: 'purpose/kredittkort' },
        { text: 'Boliglån', subtitle: 'Refinansier boliglånet', url: '/boliglan/', icon: 'purpose/bolig' },
        { text: 'Mine tilbud', subtitle: 'Sjekk dine tilbud', url: '/mine-tilbud/', icon: 'purpose/regninger' },
      ],
    },
    {
      title: 'Få oversikt',
      links: [
        { text: 'Lendo SmartØkonomi', subtitle: 'Logg inn og få oversikt', url: '/min-side/logg-inn/', icon: 'icon/arrow-right-to-bracket-light' },
        { text: 'Kredittsjekk deg selv', subtitle: 'Se din kredittscore', url: '/kredittsjekk/', icon: 'icon/score' },
        { text: 'Boligverdi', subtitle: 'Se din boligverdi', url: '/boliglan/boligverdi/', icon: 'purpose/bolig' },
        { text: 'Gjeldoversikt', subtitle: 'Se din usikrede gjeld', url: '/gjeldsregister/gjeldsoversikt/', icon: 'icon/piechart' },
        { text: 'Gjeldfri', subtitle: 'Bli raskere gjeldfri', url: '/gjeldsregister/gjeldfri/', icon: 'icon/barchart' },
        { text: 'Hvor mye kan jeg låne', subtitle: 'Se estimert låneevne', url: '/forbrukslan/hvor-mye-kan-jeg-laane/', icon: 'icon/hmkjl' },
      ],
    },
  ],
  secondaryNav: [
    {
      title: 'Kalkulatorer',
      links: [
        { text: 'Lånekalkulator', url: '/lanekalkulator/' },
        { text: 'Billånskalkulator', url: '/billan/billanskalkulator/' },
        { text: 'Kredittkortkalkulator', url: '/kredittkort/kredittkort-kalkulator/' },
        { text: 'Boliglånskalkulator', url: 'boliglan/boliglanskalkulator/' },
        { text: 'Forbrukslånkalkulator', url: '/forbrukslan/forbrukslan-kalkulator/' },
        { text: 'Sparekalkulator', url: '/sparekalkulator/' },
      ],
    },
    {
      title: 'Kontakt oss',
      links: [
        { text: 'Ofte stilte spørsmål', url: '/ofte-stilte-sporsmal/generelt/' },
        { text: 'Kontakt oss', url: '/kontakt-oss/' },
      ],
    },
    {
      title: 'Om oss',
      links: [
        { text: 'Om oss', url: '/om-lendo/' },
        { text: 'Våre banker', url: '/lendo-banker/' },
        { text: 'Snakk om gjeld', url: '/snakkomgjeld/' },
      ],
    },
  ],
};
